import { INSTALLER_MENU, PATHS } from '../utils/constants';
import { getAppIndexConf, updateAppConfState } from '../services/account';
import { Modal } from 'antd';

export default {
  namespace: 'appIndex',
  state: {
    data: []
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *loadAppIndexCof(_, { put, call, select }) {
      const { locale } = yield select(state => state.i18n);
      const { status, msg, data } = yield call(getAppIndexConf, { locale });
      if (status === 0) {
        yield put({ type: 'update', payload: { data } });
      } else {
        Modal.error({ content: msg });
      }
    },
    *updateState(
      {
        payload: { id, state: newState }
      },
      { put, call, select }
    ) {
      const { locale } = yield select(state => state.i18n);
      const { data } = yield select(state => state.appIndex);
      const showConf = data.filter(x => x.state === 0);
      if (newState === 0 && showConf.length >= 4) {
        Modal.error({ content: '请最多选择四个进行展示!' });
        return;
      }
      if (newState === 1 && showConf.length <= 2) {
        Modal.error({ content: '请最少选择两个进行展示!' });
        return;
      }
      const { status, msg } = yield call(updateAppConfState, {
        id,
        state: newState,
        locale
      });
      if (status === 0) {
        yield put({ type: 'loadAppIndexCof' });
      } else {
        Modal.error({ content: msg });
      }
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.appIndex) {
          const token = sessionStorage.getItem('token');
          const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
          if (token && userInfo && userInfo.roleId === 0) {
            dispatch({ type: 'loadAppIndexCof' });
            dispatch({
              type: 'menu/setMenus',
              menus: { data: INSTALLER_MENU, status: 0 }
            });
          } else {
            dispatch({ type: 'top/logOff' });
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/appIndexConf.js